export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/default-avatar-a9615bac158705203261e8348f574cc8.png";